import { openModal } from '@core/components/ModalStack';
import { CopyBlockTemplateModalProps } from './CopyBlockTemplateModal';

export async function openCopyBlockTemplateModal(props: CopyBlockTemplateModalProps) {
  const { CopyBlockTemplateModal } = await import('./CopyBlockTemplateModal');
  openModal(CopyBlockTemplateModal, props);
}

export * from './CopyBlockTemplateModal';
